import BaseService from "./base.service";
const service = new BaseService("/projects")

service.reportAuthToken = function(id, config){
  const path = this._getResource() + `/${id}/report_auth_token`
  return this.http.get(path, config);
}

service.groupedEquipments = function(id, params = {}) {
  const path = this._getResource() + `/${id}/grouped_equipments`;
  return this.http.get(path, { params });
};

export default service;
